import React from 'react';

export default function SupportLine({ supportUrl, supportPhone }) {
    // Non-internal distributors get a phone number; everyone else keeps the
    // tech-support link. The controller only sends supportPhone for the former.
    if (supportPhone) {
        return (
            <p className="text-center demo-island-support-line" data-testid="demo-add-support">
                {__('Need help? Contact us at')}{' '}
                <a href={`tel:+1${supportPhone}`} className="demo-add-support-link">{supportPhone}</a>.
            </p>
        );
    }

    return (
        <p className="text-center demo-island-support-line" data-testid="demo-add-support">
            {__('Do not see the business?')} <a href={supportUrl} target="_blank" rel="noopener" className="demo-add-support-link">{__('Submit a support request')}</a> {__('for immediate assistance.')}
        </p>
    );
}
